import React, { Component } from 'react';
import classes from './ScreenshotsContainer.module.css'
import '../../Transitions.css'
import Screenshots from '../../components/Screenshots/Screenshots';
import GalleryHeader from '../../components/GalleryHeader/GalleryHeader';
import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner'
import axios from '../../axios-shots';


class ScreenshotsContainer extends Component {
    state = {
        selectedImageURI: null,
        imgURIArray: this.props.imgURIArray,
        sessionScreenshots: true,
        retrievedArray: null,
        loading: false,
        showFailed: false,
        dbScreenshotsVisible: false,
        retrieveFromDB: false
    }

    componentDidMount() {
        let uriArray = [];
        this.setState({ loading: true })
        axios.get('/screenshots.json')
            .then(response => {
                this.setState({ loading: false })
                Object.keys(response.data).forEach(key => {
                    uriArray.push(response.data[key])
                })
                this.setState({ retrievedArray: uriArray })
            })
            .catch(error => {
                this.setState({ loading: false })

                this.setState({ showFailed: true })
            });
    }

    getSelectedImageFromContainerHandler(selectedImageURI) {
        this.setState({ selectedImageURI: selectedImageURI })
    }

    showDBcontainer = () => {
        let uriArray = this.state.retrievedArray;
        this.setState({ dbScreenshotsVisible: true })
        if (uriArray) {
            this.setState({ imgURIArray: uriArray, showFailed: false })
        } else {
            this.setState({ showFailed: true })
            this.props.notify(false, "No data from database.")
        }
    }
    showScreenshots = () => {
        this.setState({ dbScreenshotsVisible: false })
        this.setState({ imgURIArray: this.props.imgURIArray })
    }

    render() {
        const spinner = (
            <div className={classes.Loader}>
                <Spinner type={2} />
            </div>
        )
        const failed = (
            <div className={classes.Failed}>
                <i className="far fa-frown-open"></i>
                <p>Unable to load from database</p>
            </div>
        )

        return (
            <div className={this.state.dbScreenshotsVisible ? classes.DBScreenshotsContainer : classes.ScreenshotsContainer}>
                <Button icon={"fas fa-times"} type={"button-error"} gridClass={""} buttonName={""} style={{ width: "20%", height: "5%", float: "right" }} onClick={this.props.showScreenshotContainerHandler} />
                <GalleryHeader />
                <div style={{ width: "100%" }}>
                    <Button buttonName={"Session"} style={{ width: "50%", backgroundColor: "#222f3e", color: "white", boxShadow: "0px 0px 0px 5px rgba(0,0,0,0.1)" }} onClick={() => this.showScreenshots} />
                    <Button buttonName={"Database"} style={{ width: "50%", boxShadow: "0px 0px 0px 5px rgba(0,0,0,0.1)" }} onClick={() => this.showDBcontainer} />
                </div>
                {this.state.loading ? spinner : null}
                {this.state.showFailed && this.state.dbScreenshotsVisible ? failed : null}

                <Screenshots imgURIArray={this.state.imgURIArray}
                    getSelectedImageFromContainerHandler={imgURI => this.props.getSelectedImageFromContainerHandler(imgURI)} />
                {this.state.showFailed ? failed : null}
            </div>
        );
    }
}
export default ScreenshotsContainer;